export default __webpack_public_path__ + "static/media/blue-remove-icon.0b8a5f21.svg";